export default __webpack_public_path__ + "static/media/brand-logo.274ae840.svg";